import React from 'react';

import { useContext as useUsersContext } from 'components/Users/Context';

import { Link } from 'react-router-dom';
import routes from 'app/routes';

export default function ChangeEmailStep() {
  const { state: stateUsers } = useUsersContext();

  return (
    <>
      <h4>Step 1. Update Your Email Address</h4>
      <div className="mb-3 row">
        <div className="col-lg-6 mt-2">
          <b>Please enter your new email address:</b>
          <p>{stateUsers.user.attributes.email}</p>
        </div>
        <div className="col-lg-6 mt-2">
          <div className="d-flex justify-content-lg-end gap-2">
            <Link
              to={routes.members.activateProgram.emailUpdate}
              className="btn btn-outline-primary"
              style={{ width: '180px' }}
            >
              Update Email
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
